<template>
  <div class="form-range">
    <h1 class="title">{{questionTitle}}</h1>

    <div class="range-wrapper">
      <div v-if="answerLoaded">
        <ul class="range-labels">
          <li
            v-for="(number, i) in max + 1"
            :key="number"
            @click="moveSlider(i)"
            :class="[{ 'primary': value == i }, {'list-item': value != i}]">
            {{i}}
          </li>
        </ul>

        <input
          type="range"
          :min="min"
          :max="max"
          step="0"
          :class="thumbClass"
          v-model="value"
          @input="moveSlider(value)">

        <ul class="satisfaction-info">
          <!-- <li>{{question.answer.range_labels}}</li> -->
          <li class="has-pointer" v-for="item in questionLabels" :key="item.key" @click="moveSlider(item.key)">
            {{item.translation_entries[0].body}}
          </li> 
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'

import {getQuestionnaireAnswer} from '@/api/questionnaire'

const MEDIUM_THRESHOLD = 3
const GOOD_THRESHOLD = 7

export default {
  name: 'FormRange',

  components: {RpSprite},

  mounted() {
    this.checkQuestionStatus()
  },

  props: {
    question: Object,
    questionTitle: String
  },

  data() {
    return {
      selectedAnswer: false,
      confirm: false,
      value: 5,
      min: 0,
      max: 10,
      thumbClass: 'rating-neutral',
      answerLoaded: false
    }
  },

  validations: {selectedAnswer: {required}},

  methods: {
    moveSlider(num) {
      this.value = parseInt(num)

      this.$emit('update', this.answerPayload)

      if(this.value <= MEDIUM_THRESHOLD) {
        this.thumbClass = (this.isInverseScore) ? 'rating-happy' : 'rating-sad'
      } else if(this.value > MEDIUM_THRESHOLD && this.value < GOOD_THRESHOLD) {
        this.thumbClass = 'rating-neutral'
      } else {
        this.thumbClass = (this.isInverseScore) ? 'rating-sad' : 'rating-happy'
      }
    },

    checkQuestionStatus() {
      // Check if the question has been answered
      const questionId = this.question.id

      getQuestionnaireAnswer(questionId, this.patientId, this.questionnaireId)
        .then((response) => {
          const hasAnswer = response.data[0].answer.id

          if(hasAnswer) {
            this.$emit('answered', true)
            // console.log('Question answered')

            // Set answered answer
            const answer = response.data[0].value

            this.selectedAnswer = answer
            this.value = answer

            this.$emit('currentQuestionAnswer', response.data[0])
            // console.log('value za emit', this.value)
            // this.$emit('update', this.answerPayload)

            if(this.value <= MEDIUM_THRESHOLD) {
              this.thumbClass = (this.isInverseScore) ? 'rating-happy' : 'rating-sad'
            } else if(this.value > MEDIUM_THRESHOLD && this.value < GOOD_THRESHOLD) {
              this.thumbClass = 'rating-neutral'
            } else {
              this.thumbClass = (this.isInverseScore) ? 'rating-sad' : 'rating-happy'
            }
          } else {
            this.$emit('answered', false)
            // console.log('Question not yet answered')
          }

          this.answerLoaded = true
        })
        .catch(() => {
          this.answerLoaded = true
        })
    }
  },

  computed: {
    answerPayload() {
      return {
        id: this.question.id,
        value: this.value
      }
    },

    questionLabels() {
      const question = this.question.answer.range_labels
      const sorted = question.sort((a, b) => {
        if(a.key > b.key) {
          return 1
        } else if(b.key > a.key) {
          return -1
        }

        return 0
      })

      if (sorted.length === 4) {
        sorted.splice(sorted.length / 2, 0, {key: 5, translation_entries: [{body: ''}]})
      }

      return sorted
    },
    patientId() {
      return this.$route.params.id
    },
    questionnaireId() {
      return this.$route.params.questionnaireId
    },

    isInverseScore() {
      return this.question.inverse_score
    },
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.range-wrapper
  min-height: 60px

.form-range
  display: flex
  flex-flow: row wrap
  text-align: left
  flex-direction: column
  padding-top: 30px

  .title
    padding-bottom: 25px

  .range-labels
    display: flex
    justify-content: space-between
    padding: 0 10px
    margin: 0 6px

    .list-item
      position: relative
      display: flex
      justify-content: center
      text-align: center
      width: 1px
      height: 1px
      flex: 0 1 auto
      list-style-type: none
      font-weight: $font-bold
      line-height: 20px
      transition: opacity .2s ease
      font-size: 16px
      cursor: pointer

    .primary
      position: relative
      display: flex
      justify-content: center
      text-align: center
      width: 2px
      line-height: 18px
      flex: 0 1 auto
      opacity: 1
      list-style-type: none
      font-size: 22px
      transition: opacity .2s ease
      font-weight: $font-bold
      cursor: pointer

  .satisfaction-info
    display: flex
    justify-content: space-between
    width: 100%
    padding: 0
    font-size: 18px
    font-weight: 500

    li
      display: block
      flex: 1 0 0
      list-style-type: none
      text-align: center
      
      &.is-pointer
      cursor: pointer

    li:first-child
      text-align: left

    li:last-child
      text-align: right 

  input[type=range]
    -webkit-appearance: none
    margin: 18px 0
    width: 100%

  input[type=range]:focus
    outline: none

  input[type=range]::-webkit-slider-runnable-track
    width: 100%
    height: 0.30px
    cursor: pointer
    background: blue

    border: 2px solid #010101

  input[type=range]::-webkit-slider-thumb
    border: 2px solid white
    height: 30px
    width: 30px
    border-radius: 50%
    /* TODO: use the svg sprite */
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path fill='none' d='M0 0h24v24H0V0z'/><circle cx='15.5' fill='white' cy='9.5' r='1.5'/><circle fill='white' cx='8.5' cy='9.5' r='1.5'/><path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' fill='white'/></svg>")
    background-size: 2.2rem
    background-color: $color-very-diss
    background-repeat: no-repeat
    background-position: 0.2rem
    color-adjust: #fff
    fill: yellow
    box-shadow: 0 3px 5px 0 $color-shadow
    cursor: pointer
    -webkit-appearance: none
    margin-top: -1.4rem

  input[type="range"]
    &.rating-neutral
      &::-webkit-slider-thumb
        background-color: $color-neutral
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M9 14h6v1.5H9z' fill='white'/><circle cx='15.5' cy='9.5' r='1.5' fill='white'/><circle cx='8.5' cy='9.5' r='1.5' fill='white'/><path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' fill='white'/></svg>")

    &.rating-happy
      &::-webkit-slider-thumb
        background-color: $color-satisfied
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'><path d='M6 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm6 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3 5.5c2.14 0 3.92-1.5 4.38-3.5H4.62c.46 2 2.24 3.5 4.38 3.5zM9 1C4.57 1 1 4.58 1 9s3.57 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-3.59 0-6.5-2.91-6.5-6.5S5.41 2.5 9 2.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z' fill='white'/></svg>")

  input[type=range]
    &:focus
      &::-webkit-slider-runnable-track
        background: blue // OVO JE GLAVNA BOJA

    &::-moz-range-track
      width: 100%
      height: 0.30px
      cursor: pointer
      background: blue
      border-radius: 1.3px
      border: 2px solid #010101

    &::-moz-range-thumb
      border: 2px solid white
      height: 30px
      width: 30px
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><circle cx='15.5' cy='9.5' r='1.5' fill='#fff'/><circle cx='8.5' cy='9.5' r='1.5' fill='#fff'/><path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' fill='#fff'/></svg>")
      background-size: 2.2rem
      background-color: $color-very-diss
      background-repeat: no-repeat
      background-position: 0.4rem
      border-radius: 50%
      background-size: 2.2rem
      background-repeat: no-repeat
      box-shadow: 0 3px 5px 0 $color-shadow
      cursor: pointer

    &.rating-sad
      &::-moz-range-thumb
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><circle cx='15.5' cy='9.5' r='1.5' fill='white'/><circle cx='8.5' cy='9.5' r='1.5' fill='white'/><path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' fill='white'/></svg>")
        background-color: $color-very-diss

    &.rating-neutral
      &::-moz-range-thumb
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M9 14h6v1.5H9z' fill='white'/><circle cx='15.5' cy='9.5' r='1.5' fill='white'/><circle cx='8.5' cy='9.5' r='1.5' fill='white'/><path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' fill='white'/></svg>")
        background-color: $color-neutral

    &.rating-happy
      &::-moz-range-thumb
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'><path d='M6 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm6 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3 5.5c2.14 0 3.92-1.5 4.38-3.5H4.62c.46 2 2.24 3.5 4.38 3.5zM9 1C4.57 1 1 4.58 1 9s3.57 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-3.59 0-6.5-2.91-6.5-6.5S5.41 2.5 9 2.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z' fill='white'/></svg>")
        background-color: $color-satisfied

    &::-ms-track
      width: 100%
      height: 0.30px
      cursor: pointer
      background: transparent
      border-color: transparent
      border-width: 16px 0
      color: transparent

    &::-ms-fill-lower
      background: blue
      border: 0.2px solid #010101
      border-radius: 2.6px

    &::-ms-fill-upper
      background: blue
      border: 0.2px solid #010101
      border-radius: 2.6px

    &::-ms-thumb
      border: 1px solid #000000
      height: 36px
      width: 16px
      border-radius: 3px
      background: #ffffff
      cursor: pointer

    &:focus
      &::-ms-fill-lower,
      &::-ms-fill-upper
        background: blue
</style>



// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Elements/Range.vue